import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link,useOutletContext } from "react-router-dom";
import { currency_converter_inr, currency_converter_selected } from "../../../utils/currencyUtils";
import ProgressBar from "react-bootstrap/ProgressBar";
import { MaterialReactTable } from "material-react-table";
import RevenueCollectionAge from "./components/RevenueCollectionAge";
import { openInAppTab } from "../../../utils/tabNavigation";
import InvoiceStatusCell from "../../client/InvoiceStatusCell";

function Commercial() {
  const { selectedUser, year, setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  function RevenueCounter({ value, format = true }) {
      const safeValue = Number(value) || 0;
      return (
          <CountUp
              start={0}
              end={safeValue}
              duration={1}
              formattingFn={format ? currency_converter_selected : undefined}
          />
      );
  }  

  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch (error) {
    console.error("Error reading user data:", error);
  }
  const defaultCurrencyId = Number(user?.default_currency_id || 1);
  const amountDivisor = defaultCurrencyId === 1 ? 100000 : 1000;
  const amountSuffix = defaultCurrencyId === 1 ? "L" : "K";

  useEffect(()=>{
    if(!selectedUser) return;
    let isLatest = true; 
    const getOverview = async ()=>{
    try{
    setGlobalLoading(true);    
    const response = await axios.get(`${REACT_APP_API_BASE_URL}/performance/commercial`,
     {
        params:{ user_id:selectedUser.id, year:year },
        headers: { Authorization: `Bearer ${token}` },
     }
    );
     if (!isLatest) return;
    const d = response.data;
    console.log("commercial response", response.data);
    const not_raised_rev = (Math.floor((d?.funnel_summary?.[0]?.not_raised_amount || 0) / amountDivisor)).toLocaleString('en-IN') + amountSuffix;
    const unissued_rev = (Math.floor((d?.funnel_summary?.[0]?.unissued_amount || 0) / amountDivisor)).toLocaleString('en-IN') + amountSuffix;
    const issued_rev = (Math.floor((d?.funnel_summary?.[0]?.issued_amount || 0) / amountDivisor)).toLocaleString('en-IN') + amountSuffix;
    const collected_rev = (Math.floor((d?.funnel_summary?.[0]?.collected_revenue || 0) / amountDivisor)).toLocaleString('en-IN') + amountSuffix;
    if(response.status === 200) {
        setData({
          ...d,
          not_raised_rev,
          unissued_rev,
          issued_rev,
          collected_rev,
        });
        setoptions(d?.client_summary || []);
    }

    }catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getOverview();
     return () => {
        isLatest = false; // cancel old request
    };
    
    },[selectedUser,year]);

 const columns = [
    {
      accessorKey: "company_name",
      header: "Company Name",
      size: 300,
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 3,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 1,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      Cell: ({ row }) => {
        return (
          <div className="d-flex align-items-center file-name-icon">
            <a
              href={`/client/view/${row.original.client_id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${row.original.client_id}`); }}
              className="avatar avatar-md border rounded-circle"
              target="_blank"
            >
              <img
                src={
                  row.original.logo
                    ? `${PINE_BASE_URL}/files/companyLogo/${row.original.logo}`
                    : `${PINE_BASE_URL}/files/companyLogo/nologo.png`
                }
                className="img-fluid"
                alt="logo"
                style={{ width: "40px", height: "40px", objectFit: "contain" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${PINE_BASE_URL}/files/companyLogo/nologo.png`;
                }}
              />
            </a>
            <div className="ms-2">
              <h6 className="fw-medium mb-0">
                <Link
                  to={`/client/view/${row.original.client_id}`}
                >
                  {row.original.company_name}
                </Link>
              </h6>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "amount",
      header: "Revenue",
      size: 100,
      Cell: ({ cell, row }) => (
        <span
          onClick={() => openAgingDetails(row.original.client_id)}
          style={{
            cursor: "pointer",
            color: "#1976d2",
            textDecoration: "underline",
          }}
          title="View collected invoice details"
        >
          {currency_converter_selected(cell.getValue() ?? 0)}
        </span>
      ),
    },
    {
      accessorKey: "days_outstanding",
      header: "Collection Days",
      size: 100,
      Cell: (info) =>
        info.cell.getValue() !== null ? info.cell.getValue() : "NA",
    },
    {
      accessorKey: "category",
      header: "Category",
      size: 100,
      Cell: ({ row }) => {
        const status = row.original.category;

        const statusMap = {
          ">180 days": "danger",
          "90-180 days": "warning",
          "60-90 days": "secondary",
          "30-60 days": "info",
          "<30 days": "success",
        };

        const btnClass = statusMap[status] || "secondary";

        return (
          <button
            type="button"
            className={`btn btn-soft-${btnClass} rounded-pill py-0 px-2`}
            style={{ fontSize: "12px", lineHeight: "1.5" }}
          >
            {status}
          </button>
        );
      },
     },
    {
      accessorKey: "status",
      header: "Status",
      size: 100,
      Cell: ({ row }) => {
        const status = row.original.status;

        const statusMap = {
          Critical: "danger",
          Warning: "warning",
          Moderate: "secondary",
          Normal: "info",
          Good: "success",
        };

        const btnClass = statusMap[status] || "secondary";

        return (
          <button
            type="button"
            className={`btn btn-soft-${btnClass} rounded-pill py-0 px-2`}
            style={{ fontSize: "12px", lineHeight: "1.5" }}
          >
            {status}
          </button>
        );
      },
    }
  ];

const [agingModalOpen, setAgingModalOpen] = useState(false);
const [agingDetails, setAgingDetails] = useState([]);
const [agingDetailsLoading, setAgingDetailsLoading] = useState(false);

const openAgingDetails = async (companyId) => {
  setAgingModalOpen(true);
  setAgingDetailsLoading(true);

  try {
    const response = await axios.get(
      `${REACT_APP_API_BASE_URL}/performance/collection_aging_details`,
      {
        params: {
          user_id: selectedUser?.id || selectedUser,
          year,
          company_id: companyId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setAgingDetails(response.data?.data || []);
  } catch (error) {
    console.error(
      "Unable to load collection details:",
      error.response?.data || error
    );
    setAgingDetails([]);
  } finally {
    setAgingDetailsLoading(false);
  }
};


  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="border-bottom mb-3 pb-3">
            <h4>Commercial Discipline</h4>
            <p className="text-muted fs-13 mb-1">Track invoicing & collection health</p>
          </div>
          <div className="row">
            <div className="col-xl-2 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-building`}></i>
                                Total Invoiced
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data?.invoice_summary?.[0]?.total_revenue)}/>{amountSuffix}</h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-2 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-check-circle`}></i>
                                Collected
                            </p>
                            <h3 className="counter text-success"><RevenueCounter value={Number(data?.invoice_summary?.[0]?.collected_revenue)} />{amountSuffix}</h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-2 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-exclamation-circle`}></i>
                                Pending
                            </p>
                            <h3 className="counter text-warning"><RevenueCounter value={Number(data?.invoice_summary?.[0]?.pending_revenue)} />{amountSuffix}</h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-clock`}></i>
                                Avg Collection Days
                            </p>
                            <h3 className="counter" style={{ color: "#0da2e7" }}>{data?.invoice_summary?.[0]?.avg_collection_days}</h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-arrow-trend-up`}></i>
                                Collection Rate
                            </p>
                            <h3 className="counter" style={{color:"#14b8a5"}}>{data?.invoice_summary?.[0]?.collection_rate_percentage}%</h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
          </div>
          <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                <h5>Invoicing Funnel</h5>
          </div>
          <div className="row">
            <div className="col-xl-6 col-md-6">
            <div className={`card flex-fill`}>
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Not Raised <span className="fs-14 fw-medium mb-0 text-primary mb-1 ms-1">{data?.funnel_summary?.[0]?.not_raised_invoices || 0} <span className="fs-12 text-gray-5">(<span className="fw-bold">{data?.not_raised_rev}</span>)invoices</span></span>
                </div>
                <div className="progress progress-md mb-2">
                    <ProgressBar
                    animated
                    max={data?.funnel_summary?.[0]?.total_revenue || 1}
                    variant="primary"
                    now={data?.funnel_summary?.[0]?.not_raised_amount || 0}
                    />
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                    Unissued <span className="fs-14 fw-medium mb-0 text-warning mb-1 ms-1">{data?.funnel_summary?.[0]?.unissued_invoices || 0} <span className="fs-12 text-gray-5">invoices(<span className="fw-bold">{data?.unissued_rev}</span>)</span></span>
                </div>
                <div className="progress progress-md mb-2">
                    <ProgressBar
                    animated
                    max={data?.funnel_summary?.[0]?.total_revenue || 1}
                    variant="warning"
                    now={data?.funnel_summary?.[0]?.unissued_amount || 0}
                    />
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                    Issued <span className="fs-14 fw-medium mb-0 text-info mb-1 ms-1">{data?.funnel_summary?.[0]?.issued_invoices || 0} <span className="fs-12 text-gray-5">invoices(<span className="fw-bold">{data?.issued_rev}</span>)</span></span>
                </div>
                <div className="progress progress-md mb-2">
                    <ProgressBar
                    animated
                    max={data?.funnel_summary?.[0]?.total_revenue || 1}
                    variant="info"
                    now={data?.funnel_summary?.[0]?.issued_amount || 0}
                    />
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                    Collected <span className="fs-14 fw-medium mb-0 text-success mb-1 ms-1">{data?.funnel_summary?.[0]?.collected_invoices || 0} <span className="fs-12 text-gray-5">invoices (<span className="fw-bold">{data?.collected_rev}</span>)</span></span>
                </div>
                <div className="progress progress-md mb-2">
                    <ProgressBar
                    animated
                    max={data?.funnel_summary?.[0]?.total_revenue || 1}
                    variant="success"
                    now={data?.funnel_summary?.[0]?.collected_amount || 0}
                    />
                </div>                
                </div>
            </div>    
            </div>
            <div className="col-xl-6 col-md-6">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                    Collection Age Buckets
                  </h5>
                </div>
                <div className="card-body d-flex justify-content-center align-items-center" style={{ height: "280px" }}>
                  <RevenueCollectionAge chart_data={data?.revenue_collection_age} />
                </div>
              </div>
            </div>
          </div>
        {agingModalOpen && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <div>
                    <h5 className="modal-title">
                      Role-wise collected invoice details
                    </h5>
                  </div>

                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setAgingModalOpen(false)}
                  />
                </div>

                <div className="modal-body">
                  {agingDetailsLoading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Role Name</th>
                            <th>Invoice Status</th>
                            <th className="text-end">Received Amount</th>
                            <th className="text-end">Original Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          {agingDetails.length ? (
                            agingDetails.map((row) => (
                              <tr key={row.invoice_item_id}>
                                <td>{row.role_name || "—"}</td>

                                <td>
                                  {/* Replace with your existing status-icon component. */}
                                  <InvoiceStatusCell role_id={row.role_id} />
                                </td>

                                <td className="text-end">
                                  {currency_converter_selected(row.received_amount)}
                                </td>

                                <td className="text-end">
                                  {row.currency}{row.original_received_amount}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center py-4">
                                No collected invoices found for this aging bucket.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setAgingModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}  
          <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                <h5>Collection Aging Details</h5>
          </div>
          <div className="row">
            <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={options}
                initialState={{
                  pagination: { pageSize: 200 },
                }}
                muiTableBodyRowProps={{
                  sx: {
                    height: "20px", // compact row height
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
              />
            </div>
          </div>
          </div> 
        </div>
      </div>
    </>
  );
}

export default Commercial;
